import { CodedError } from '../../CodedError';
import { errorCodes } from '../../constants/errorCodes';

export class EssensysBookingZeroAmountError extends CodedError {
  static get errorName() {
    return errorCodes.essensysBookingZeroAmountError.code;
  }

  constructor(message: string = errorCodes.essensysBookingZeroAmountError.message) {
    super(message);
    this.code = errorCodes.essensysBookingZeroAmountError.code;
    this.message = `${message} ${errorCodes.essensysBookingZeroAmountError.code}`;
    this.name = errorCodes.essensysBookingZeroAmountError.name;
  }
}
